import React from 'react';
import { Title } from './Modal.styles';
const ModalTitle = ({ modalTitle }) => {
    return React.createElement(Title, { "data-testid": "modal-title" }, modalTitle !== null && modalTitle !== void 0 ? modalTitle : '');
};
export default ModalTitle;
//# sourceMappingURL=ModalTitle.js.map